
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner, Badge } from 'react-bootstrap';
import './OPAC.css';

const OPAC = () => {
  const containerStyle = {
    minHeight: '50vh',
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('/image.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    position: 'relative'
  };

  const [card_number, setcard_number] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [member, setMember] = useState(null);
  const [books, setBooks] = useState([]);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [myRequests, setMyRequests] = useState([]);
  const [showRequests, setShowRequests] = useState(false);
  const [showBookCopies, setShowBookCopies] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [bookCopies, setBookCopies] = useState([]);
  const [copiesPage, setCopiesPage] = useState(1);
  const [copiesTotalPages, setCopiesTotalPages] = useState(1);
  const [totalCopies, setTotalCopies] = useState(0);

  // 🔥 Filter useEffect - Jab bhi books, searchTerm, ya selectedCategory change ho
  useEffect(() => {
    if (!books.length) {
      setFilteredBooks([]);
      return;
    }

    const filtered = books.filter(book => {
      // Category filter - AB YEH BOOK ID SE FILTER HO RAHA HAI
      if (selectedCategory) {
        // 🔥 IMPORTANT: selectedCategory ab book.id hai, category_id nahi
        if (String(book.id) !== String(selectedCategory)) {
          return false;
        }
      }

      // Search filter
      if (searchTerm) {
        const term = searchTerm.toLowerCase().trim();
        const isbn = book.isbn ? String(book.isbn).toLowerCase() : '';
        const title = book.title ? book.title.toLowerCase() : '';
        const author = book.author_name ? book.author_name.toLowerCase() : '';

        if (!isbn.includes(term) && !title.includes(term) && !author.includes(term)) {
          return false;
        }
      }

      return true;
    });

    setFilteredBooks(filtered);
    console.log("Filtered books:", filtered);
  }, [selectedCategory, searchTerm, books]);

  useEffect(() => {
    if (card_number.length > 0) {
      verifyMember();
    } else {
      setMember(null);
      setBooks([]);
      setFilteredBooks([]);
    }
  }, [card_number]);

  useEffect(() => {
    if (member) {
      loadCategories();
      loadBooks();
    }
  }, [member]);

  const calculateAge = (dob) => {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const getAgeAppropriateCategories = () => {
    if (!member) return categories;
    const memberAge = calculateAge(member.dob);
    return categories.filter(category => {
      return true;
    });
  };

  const getAgeAppropriateBooks = (books) => {
    if (!member) return books;
    const memberAge = calculateAge(member.dob);
    return books.filter(book => {
      if (book.min_age) {
        return memberAge >= book.min_age;
      }
      return true;
    });
  };

  const verifyMember = async () => {
    if (!card_number) return;

    setLoading(true);
    setError('');

    try {
      const response = await fetch('http://localhost:3003/api/opac/verify-member', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ card_number })
      });

      const data = await response.json();

      if (data.success) {
        setMember(data.member);
        setSuccess('Member verified successfully!');
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError(data.message || 'Member verification failed');
        setMember(null);
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to verify member. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const loadCategories = async () => {
    try {
      const response = await fetch('http://localhost:3003/api/opac/categories');
      const data = await response.json();
      if (data.success) {
        setCategories(data.data);
      }
    } catch (err) {
      console.error('Failed to load categories:', err);
    }
  };

  const loadBooks = async (pageNum = 1) => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: pageNum,
        limit: 12
      });

      if (searchTerm) params.append('search', searchTerm);
      if (selectedCategory) params.append('category', selectedCategory);
      if (member?.branchId) params.append('branchId', member.branchId);

      const response = await fetch(`http://localhost:3003/api/opac/books?${params}`);
      const data = await response.json();

      if (data.success) {
        const ageFilteredBooks = getAgeAppropriateBooks(data.data);
        setBooks(ageFilteredBooks);
        setFilteredBooks(ageFilteredBooks); // 🔥 Initially filteredBooks bhi set karo
        setTotalPages(data.pagination.totalPages);
        setPage(pageNum);
      }
    } catch (err) {
      setError('Failed to load books');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    loadBooks(1);
  };

  const handleRequestBook = async (book) => {
    if (!member) {
      setError('Please verify your membership first');
      setTimeout(() => setError(''), 3000);
      return;
    }

    setSelectedBook(book);
    setShowBookCopies(true);
    setCopiesPage(1);
    loadBookCopies(book.id);
  };

  const loadBookCopies = async (bookId, pageNum = 1) => {
    try {
      setLoading(true);
      const response = await fetch(`http://localhost:3003/api/opac/book-copies?bookId=${bookId}&page=${pageNum}&limit=10`);
      const data = await response.json();

      if (data.success) {
        setBookCopies(data.data);
        setCopiesTotalPages(data.pagination.totalPages);
        setTotalCopies(data.pagination.totalItems);
        setCopiesPage(pageNum);
      } else {
        setError('Failed to load book copies');
      }
    } catch (err) {
      setError('Failed to load book copies');
    } finally {
      setLoading(false);
    }
  };

  const handleCopiesPageChange = (newPage) => {
    loadBookCopies(selectedBook.id, newPage);
  };

  const requestSpecificCopy = async (copyId) => {
    if (!member || !selectedBook) {
      setError('Please verify your membership first');
      setTimeout(() => setError(''), 3000);
      return;
    }

    try {
      const response = await fetch('http://localhost:3003/api/opac/request-copy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          copyId: copyId,
          bookId: selectedBook.id,
          memberId: member.id
        })
      });
      const data = await response.json();
      if (data.success) {
        setSuccess('Book copy requested successfully!');
        setTimeout(() => setSuccess(''), 3000);
        setShowBookCopies(false);
        loadBooks(page);
        if (showRequests) {
          loadMyRequests();
        }
      } else {
        setError(data.message);
        setTimeout(() => setError(''), 3000);
      }
    } catch (err) {
      setError('Failed to request book copy');
      setTimeout(() => setError(''), 3000);
    }
  };

  const loadMyRequests = async () => {
    if (!member) {
      setError('Please verify your membership first');
      setTimeout(() => setError(''), 3000);
      return;
    }

    try {
      const response = await fetch(`http://localhost:3003/api/opac/my-requests?memberId=${member.id}`);
      const data = await response.json();
      if (data.success) {
        setMyRequests(data.data);
      } else {
        setError('Failed to load requests');
      }
    } catch (err) {
      setError('Failed to load requests');
    }
  };

  useEffect(() => {
    if (showRequests && member) {
      loadMyRequests();
    }
  }, [showRequests, member]);

  const getStatusBadge = (status) => {
    const statusConfig = {
      'PENDING': { variant: 'warning', text: 'Pending' },
      'APPROVED': { variant: 'success', text: 'Approved' },
      'REJECTED': { variant: 'danger', text: 'Rejected' },
      'ISSUED': { variant: 'primary', text: 'Issued' },
      'RETURNED': { variant: 'secondary', text: 'Returned' }
    };

    const config = statusConfig[status] || { variant: 'secondary', text: status };
    return <Badge bg={config.variant}>{config.text}</Badge>;
  };

  return (
    <div className="opac-container">
      <Container className="py-4">
        {/* Member ID Input */}
        <Row className="justify-content-center mb-4">
          <Col md={8}>
            <Card className="shadow-sm border-0">
              <Card.Body className="p-3">
                <Row className="align-items-center">
                  <Col xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fs-4">📚</span>
                      <Form.Control
                        type="text"
                        placeholder="Enter Library Membership ID"
                        value={card_number}
                        onChange={(e) => setcard_number(e.target.value)}
                        size="lg"
                        className="border-secondary"
                        style={{ flex: 1 }}
                      />
                      {loading && <Spinner animation="border" size="sm" variant="secondary" />}
                    </div>
                  </Col>
                </Row>
                {member && (
                  <div className="mt-2 small text-muted">
                    Logged in as: {member.firstName} {member.lastName} | ({member.planName}) | {member.allowedBooks} books allowed | Age: {calculateAge(member.dob)} years
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Alerts */}
        {error && (
          <Row className="justify-content-center mb-3">
            <Col md={8}>
              <Alert variant="danger" onClose={() => setError('')} dismissible>
                {error}
              </Alert>
            </Col>
          </Row>
        )}

        {success && (
          <Row className="justify-content-center mb-3">
            <Col md={8}>
              <Alert variant="success" onClose={() => setSuccess('')} dismissible>
                {success}
              </Alert>
            </Col>
          </Row>
        )}

        {/* Main Content */}
        {member && (
          <>
            {/* Search and Filters */}
            <div className="search-container mb-4">
              <div className="search-content">
                <Card className="bg-transparent border-0">
                  <Card.Body>
                    <Form onSubmit={handleSearch}>
                      <Row>
                        <Col md={5}>
                          <Form.Control
                            type="text"
                            placeholder="Search books by title, author, or ISBN..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </Col>
                        <Col md={4}>
                          <Form.Select
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                          >
                            <option value="">All Books</option>
                            {/* 🔥 Ab filteredBooks use kar rahe hain */}
                            {filteredBooks.map(book => (
                              <option key={book.id} value={book.id}>
                                {book.title}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col md={2}>
                          <Button type="submit" variant="secondary" className="w-100">
                            🔍 Search
                          </Button>
                        </Col>
                        {/*    <Col md={1}>
                          <Button
                            variant="outline-light"
                            className="w-100"
                            onClick={() => setShowRequests(!showRequests)}
                            title="My Requests"
                          >
                            📋 {myRequests.length > 0 && `(${myRequests.length})`}
                          </Button>
                        </Col> */}
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
            </div>

            {/* My Requests Panel */}
            {showRequests && (
              <Card className="mb-4 shadow">
                <Card.Header className="d-flex justify-content-between align-items-center bg-light">
                  <h5 className="mb-0">My Book Requests</h5>
                  <Button variant="outline-secondary" size="sm" onClick={() => setShowRequests(false)}>
                    ✕
                  </Button>
                </Card.Header>
                <Card.Body>
                  {myRequests.length === 0 ? (
                    <p className="text-center text-muted">No requests found</p>
                  ) : (
                    <div className="requests-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {myRequests.map(request => (
                        <div key={request.id} className="request-item p-3 border-bottom">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">{request.title}</h6>
                              <small className="text-muted">by {request.author_name}</small>
                            </div>
                            <div className="text-end">
                              {getStatusBadge(request.status)}
                              <div className="mt-1">
                                <small className="text-muted">
                                  {new Date(request.requested_date).toLocaleDateString()}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}

            {/* Books Grid */}
            <div className="books-grid">
              {(() => {
                // --- UPDATE: SEARCH + CATEGORY FILTER LOGIC ---
                const filteredBooks = books.filter(book => {

                  // 1. Category Filter Check
                  // Agar category select ki gayi hai, toh check karo ki book ussi category ki hai ya nahi
                  if (selectedCategory) {
                    // Backend se usually 'category_id' ya 'categoryId' aata hai, dono check kar rahe hain
                    const bookCatId = book.category_id || book.categoryId;

                    // Agar book ki category ID selected category se match nahi karti, toh hide kar do
                    // String() isliye use kiya taaki number/string ka issue na ho
                    if (String(bookCatId) !== String(selectedCategory)) {
                      return false;
                    }
                  }

                  // 2. Text Search Filter (ISBN, Title, Author)
                  if (!searchTerm) return true; // Agar search box khali hai, toh book dikhao (kyunki category upar check ho chuki hai)

                  const term = searchTerm.toLowerCase().trim();
                  const isbn = book.isbn ? String(book.isbn).toLowerCase() : '';
                  const title = book.title ? book.title.toLowerCase() : '';
                  const author = book.author_name ? book.author_name.toLowerCase() : '';

                  // Check karo text match ho raha hai kya
                  return isbn.includes(term) || title.includes(term) || author.includes(term);
                });

                return (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 className="text-white">Available Books</h4>
                      <div className="text-white">
                        Showing {filteredBooks.length} books
                      </div>
                    </div>

                    <Row>
                      {filteredBooks.length > 0 ? (
                        filteredBooks.map(book => (
                          <Col key={book.id} md={6} lg={4} xl={3} className="mb-4">
                            <Card className="h-100 book-card shadow-sm">
                              <Card.Body className="d-flex flex-column">
                                <Card.Title className="book-title mb-2">
                                  {book.title}
                                  {book.isbn && <span className="ms-2 text-muted small">({book.isbn})</span>}
                                </Card.Title>
                                <Card.Text className="text-muted small mb-2">
                                  by {book.author_name || 'Unknown Author'}
                                </Card.Text>
                                <div className="mt-auto">
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <Badge bg="secondary">{book.category_name}</Badge>
                                    <div className="text-success">
                                      <span className="me-1">✓</span>
                                      {book.available_copies} available
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  variant="secondary"
                                  className="w-100"
                                  onClick={() => handleRequestBook(book)}
                                  disabled={book.available_copies === 0}
                                >
                                  {/* {book.available_copies > 0 ? 'Request Book' : 'Not Available'} */}
                                  {book.available_copies > 0 ? 'All Copies ' : 'Not Available'}
                                </Button>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))
                      ) : (
                        <div className="text-center text-white py-5">
                          <h5>No books found matching your criteria.</h5>
                        </div>
                      )}
                    </Row>
                  </>
                );
              })()}
            </div>


            {/* Books Grid with Pattern Background */}
            {/* <div className="books-grid">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-white">Available Books</h4>
                <div className="text-white">
                  Showing {filteredBooks.length} books
                </div>
              </div>

              <Row>
                {filteredBooks.length > 0 ? (
                  filteredBooks.map(book => (
                    <Col key={book.id} md={6} lg={4} xl={3} className="mb-4">
                      <Card className="h-100 book-card shadow-sm">
                        <Card.Body className="d-flex flex-column">
                          <Card.Title className="book-title mb-2">
                            {book.title}
                            {book.isbn && <span className="ms-2 text-muted small">({book.isbn})</span>}
                          </Card.Title>
                          <Card.Text className="text-muted small mb-2">
                            by {book.author_name || 'Unknown Author'}
                          </Card.Text>
                          <div className="mt-auto">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <Badge bg="secondary">{book.category_name}</Badge>
                              <div className="text-success">
                                <span className="me-1">✓</span>
                                {book.available_copies} available
                              </div>
                            </div>
                            <Button
                              variant="secondary"
                              className="w-100"
                              onClick={() => handleRequestBook(book)}
                              disabled={book.available_copies === 0}
                            >
                              {book.available_copies > 0 ? 'View Copies' : 'Not Available'}
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <div className="text-center text-white py-5">
                    <h5>No books found matching your criteria.</h5>
                  </div>
                )}
              </Row>
            </div>

            {/* Book Copies Panel */}
            {showBookCopies && selectedBook && (
              <Card className="mb-4 shadow-lg mt-4">
                <Card.Header className="d-flex justify-content-between align-items-center bg-light">
                  <h5 className="mb-0">{selectedBook.title}</h5>
                  <div>
                    <small className="me-3 text-muted">
                      Total: {totalCopies} | Available: {bookCopies.filter(c => c.status === 'AVAILABLE').length}
                    </small>
                    <Button variant="outline-secondary" size="sm" onClick={() => setShowBookCopies(false)}>
                      Close
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body>
                  {loading ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" variant="secondary" />
                      <p className="text-muted mt-2">Loading book copies...</p>
                    </div>
                  ) : bookCopies.length === 0 ? (
                    <div className="text-center py-4">
                      <div className="display-1 text-muted">📚</div>
                      <p className="text-muted">No copies available for this book</p>
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-hover table-bordered align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Call Number</th>
                              <th>Location</th>
                              <th>Status</th>
                              {/* <th className="text-center">Action</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {bookCopies.map((copy, index) => (
                              <tr key={copy.id}>
                                <td style={{ width: '60px' }}>
                                  {(copiesPage - 1) * 10 + index + 1}
                                </td>
                                <td>
                                  {copy.itemcallnumber ? (
                                    <span className="fw-semibold">{copy.itemcallnumber}</span>
                                  ) : (
                                    <span className="text-muted fst-italic">Not assigned</span>
                                  )}
                                </td>
                                <td>
                                  {copy.rack_location ? (
                                    <span>📍 {copy.rack_location}</span>
                                  ) : (
                                    <span className="text-muted fst-italic">Not specified</span>
                                  )}
                                </td>
                                <td style={{ width: '120px' }}>
                                  <Badge
                                    bg={copy.status === 'AVAILABLE' ? 'success' : 'secondary'}
                                    className="px-3 py-2 w-100"
                                  >
                                    {copy.status}
                                  </Badge>
                                </td>
                                {/* <td style={{ width: '120px' }} className="text-center">
                                  <Button
                                    variant={copy.status === 'AVAILABLE' ? 'secondary' : 'outline-secondary'}
                                    size="sm"
                                    disabled={copy.status !== 'AVAILABLE'}
                                    onClick={() => requestSpecificCopy(copy.id)}
                                    className="px-3 w-100"
                                  >
                                    {copy.status === 'AVAILABLE' ? 'Request' : 'Not Available'}
                                  </Button>
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination */}
                      {copiesTotalPages > 1 && (
                        <div className="d-flex justify-content-center mt-4">
                          <nav>
                            <ul className="pagination">
                              <li className={`page-item ${copiesPage === 1 ? 'disabled' : ''}`}>
                                <button
                                  className="page-link"
                                  onClick={() => handleCopiesPageChange(copiesPage - 1)}
                                >
                                  Previous
                                </button>
                              </li>
                              {[...Array(copiesTotalPages)].map((_, i) => (
                                <li key={i + 1} className={`page-item ${copiesPage === i + 1 ? 'active' : ''}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => handleCopiesPageChange(i + 1)}
                                  >
                                    {i + 1}
                                  </button>
                                </li>
                              ))}
                              <li className={`page-item ${copiesPage === copiesTotalPages ? 'disabled' : ''}`}>
                                <button
                                  className="page-link"
                                  onClick={() => handleCopiesPageChange(copiesPage + 1)}
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default OPAC;